module.exports = __webpack_public_path__ + "images/marketing/pipelinedeals-home-dashboard.png";